import App from "@/App";
import MainLayout from "@/main.layout";
import { CommersCardAds } from "@/pages/commers/cards/commers.card.ads";
import { CommersCardConversions } from "@/pages/commers/cards/commers.card.conversions";
import { CommersCardEconomics } from "@/pages/commers/cards/commers.card.economics";
import { CommersCardOrders } from "@/pages/commers/cards/commers.card.orders";
import { CommersCardPrices } from "@/pages/commers/cards/commers.card.prices";
import { CommersCardComments } from "@/pages/commers/cards/commers.card.rating";
import { CommersCardReport } from "@/pages/commers/cards/commers.card.report";
import { CommersCardShared } from "@/pages/commers/cards/commers.card.shared";
import {
  LazyCommersDashboard,
  LazyCommersOrders,
  LazyCommersProfit,
  LazyCommersRecommendedKeywords,
  LazyCommersStock,
  LazyCommersTable,
  LazyDailyKeywordReport,
} from "@/pages/commers/routes";
import { LazyCards } from "@/pages/shared";
import { LoginPage } from "@/pages/shared/login";
import { RegistrationPage } from "@/pages/shared/register";
import ResetPassword from "@/pages/shared/reset.password";
import { CompetitorsProductLayout } from "@/pages/shared/services/competitors/product/layout";
import { Navigate, Route, createRoutesFromElements } from "react-router-dom";
import { PrivateRoute } from "./private.routes";
import {
  ArticleDashboard,
  ArticleProblems,
  CategoriesBrands,
  CategoriesLayout,
  CategoriesOverview,
  CategoriesPricing,
  CompetitorService,
  CompetitorsMain,
  Dashboard,
  Review,
  SaleChannelsMarketplace,
  SaleChannelsOverview,
  SaleChannelsService,
  Support,
  Users,
} from "./router";
import { CompetitorLayout } from "@/pages/shared/services/competitors/competitor/competitor";

export const routes = createRoutesFromElements(
  <Route
    element={<App />}
    errorElement={
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-xl font-bold mb-4">404 - Страница не найдена</h1>
          <a href="/" className="text-primary underline">
            Вернуться на главную
          </a>
        </div>
      </div>
    }
  >
    <Route path="/registration" element={<RegistrationPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route
      path="/"
      element={
        <PrivateRoute>
          <MainLayout />
        </PrivateRoute>
      }
    >
      <Route path="/cards/:id" element={<LazyCards />}>
        <Route path="shared" element={<CommersCardShared />} />
        <Route path="report" element={<CommersCardReport />} />
        <Route path="ads" element={<CommersCardAds />} />
        <Route path="comments" element={<CommersCardComments />} />
        <Route path="orders" element={<CommersCardOrders />} />
        <Route path="prices" element={<CommersCardPrices />} />
        <Route path="conversions" element={<CommersCardConversions />} />
        <Route path="economics" element={<CommersCardEconomics />} />
      </Route>
      <Route path="commers">
        <Route path="dashboard" element={<LazyCommersDashboard />} />
        <Route path="table" element={<LazyCommersTable />} />
        <Route path="stock" element={<LazyCommersStock />} />
        <Route path="profit" element={<LazyCommersProfit />} />
        <Route path="orders" element={<LazyCommersOrders />} />
        <Route path="recommended-keywords" element={<LazyCommersRecommendedKeywords />} />
        <Route path="recommended-keywords/:sku" element={<LazyDailyKeywordReport />} />
        {/* <Route path="test" element={<LazyCommersTest />} /> */}
      </Route>
      <Route path="services">
        <Route path="review" element={<Review />}></Route>
        <Route path="review/:generalArticle" element={<ArticleDashboard />}>
          <Route path=":classification" element={<ArticleProblems />} />
        </Route>
        <Route path="categories" element={<CategoriesLayout />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<CategoriesOverview />} />
          <Route path="categories-brands" element={<CategoriesBrands />} />
          <Route path="pricing" element={<CategoriesPricing />} />
        </Route>
        <Route path="competitors" element={<CompetitorService />}>
          <Route index element={<Navigate to="main" replace />} />
          <Route path="main" element={<CompetitorsMain />} />
          <Route path=":sku" element={<CompetitorsProductLayout />} />
          <Route path=":sku/:competitorId" element={<CompetitorLayout />} />
        </Route>
        <Route path="sale-channels" element={<SaleChannelsService />}>
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<SaleChannelsOverview />} />
          <Route path=":marketplace" element={<SaleChannelsMarketplace />} />
        </Route>
      </Route>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="users" element={<Users />} />
      <Route path="support" element={<Support />} />
    </Route>
  </Route>
);
